import { connect } from 'react-redux'
import React, { Component } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

import { addFavorite, deleteFavorite } from 'shop/actions/shop'
import { addToFavorites, fetchWebshopFavorites } from 'shop/actions/index'
import HeartIconFilled from 'images/icons/lnr-heart-filled.svg'
import HeartIcon from 'images/icons/lnr-heart.svg'

import { WebshopContext } from '../shared'

class AddToFavorites extends Component {
  static contextType = WebshopContext

  constructor(props) {
    super(props)

    this.state = {
      favorites: {},
      isFetching: true,
      product: {},
    }

    this.addToFavorites = this.addToFavorites.bind(this)
    this.removeFromFavorites = this.removeFromFavorites.bind(this)
    this.handleClick = this.handleClick.bind(this)
  }

  componentDidMount() {
    this.setState({
      isFetching: false,
    })
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      currency: nextProps.currency,
    })
  }

  addToFavorites(product) {
    const { brand, currency, dispatch } = this.props
    const { refreshWebshopFavorites } = this.context

    this.setState({
      isFetching: true,
    })

    dispatch(addFavorite(brand.id, product.id, product.split_key)).then(response => {
      if (!response.error) {
        dispatch(fetchWebshopFavorites(brand.id, currency))
        dispatch(addToFavorites())
        this.setState({
          isFetching: false,
        })

        refreshWebshopFavorites()
      } else {
        this.setState({
          isFetching: false,
        })
      }
    })
  }

  removeFromFavorites(product) {
    const { brand, currency, dispatch } = this.props
    const { refreshWebshopFavorites } = this.context

    this.setState({
      isFetching: true,
    })

    dispatch(deleteFavorite(brand.id, product.id, product.split_key)).then(response => {
      if (!response.errors) {
        dispatch(fetchWebshopFavorites(brand.id, currency))
        this.setState({
          isFetching: false,
        })

        refreshWebshopFavorites()
      } else {
        this.setState({
          isFetching: false,
        })
      }
    })
  }

  handleClick() {
    const { isFetching } = this.state
    const { product } = this.props
    const { favorites } = this.context

    const inFavorites = favorites.products ? (
      favorites.products.findIndex(p => p.id === product.id && p.split_key === product.split_key) !== -1
    ) : false;

    if (isFetching) {
      return
    }

    if (!inFavorites) {
      this.addToFavorites(product)
    } else {
      this.removeFromFavorites(product)
    }
  }

  render() {
    const { isFetching } = this.state
    const { product } = this.props
    const { favorites } = this.context

    const inFavorites = favorites.products ? (
      favorites.products.findIndex(p => p.id === product.id && p.split_key === product.split_key) !== -1
    ) : false;

    return (
      <OverlayTrigger
        placement="top"
        overlay={tooltip(
          !inFavorites ? 'Add to favorites' : 'Remove from favorites'
        )}
      >
        <div
          className={`webshop-search-product-actions-like ${
            isFetching ? 'no-pointer ' : ''
          } `}
          onClick={() => this.handleClick()}
        >
          {isFetching && (
            <span className="fa fa-spinner fa-spin splash-spinner" />
          )}
          {!isFetching && (
            <img src={!inFavorites ? HeartIcon : HeartIconFilled} />
          )}
        </div>
      </OverlayTrigger>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currency: state.webshop.currency,
  }
}

const tooltip = message => {
  return <Tooltip id="tooltip">{message}</Tooltip>
}

export default connect(mapStateToProps)(AddToFavorites)
